var _g, _path, _path2, _rect, _rect2, _rect3, _rect4, _rect5, _ellipse, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwitchOffline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 34,
    viewBox: "0 0 46 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1138_13535)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5138 25.8253H32.1428C35.5104 25.8253 38.2404 23.0954 38.2404 19.7278C38.2404 18.7949 38.0263 17.8744 37.6147 17.0373L35.0473 11.8159C33.7482 9.17378 31.06 7.5 28.1158 7.5H17.8952C15.0412 7.5 12.4197 9.07379 11.078 11.5928L8.20605 16.9843C7.74247 17.8546 7.5 18.8255 7.5 19.8116C7.5 23.1329 10.1925 25.8253 13.5138 25.8253Z",
    fill: "#E8DEF1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5138 25.8253H32.1428C35.5104 25.8253 38.2404 23.0954 38.2404 19.7278C38.2404 18.7949 38.0263 17.8744 37.6147 17.0373L35.0473 11.8159C33.7482 9.17378 31.06 7.5 28.1158 7.5H17.8952C15.0412 7.5 12.4197 9.07379 11.078 11.5928L8.20605 16.9843C7.74247 17.8546 7.5 18.8255 7.5 19.8116C7.5 23.1329 10.1925 25.8253 13.5138 25.8253Z",
    stroke: "#510C76"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.2404 18.3098V25.8253H7.5V18.3098L13.2581 7.5H32.9252L38.2404 18.3098Z",
    fill: "#E8DEF1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 18.3098V25.8253H38.2404V18.3098M7.5 18.3098L13.2581 7.5H32.9252L38.2404 18.3098M7.5 18.3098H38.2404",
    stroke: "#510C76"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10.4756,
    y: 21.5098,
    width: 2,
    height: 2,
    fill: "#500D76"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 14.4756,
    y: 21.5098,
    width: 2,
    height: 2,
    fill: "#500D76"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 18.4756,
    y: 21.5098,
    width: 2,
    height: 2,
    fill: "#500D76"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 22.4756,
    y: 21.5098,
    width: 2,
    height: 2,
    fill: "#500D76"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 33.3438,
    y: 21.5098,
    width: 2,
    height: 2,
    fill: "#500D76"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 22.8703,
    cy: 12.5727,
    rx: 4.13349,
    ry: 2.96141,
    fill: "white",
    stroke: "#510C76"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.043 11.5654L23.6971 13.5826",
    stroke: "#510C76",
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1138_13535",
    x: 0,
    y: 0,
    width: 45.7402,
    height: 33.3252,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_1138_13535"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.831373 0 0 0 0 0.215686 0 0 0 0 0.109804 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1138_13535"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1138_13535",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitchOffline);
export default __webpack_public_path__ + "static/media/Switch-offline.4dee6d6efe4b1369993b0e100ac63eda.svg";
export { ForwardRef as ReactComponent };